module.exports = __webpack_public_path__ + "img/esmeralda-room.c50151ad.jpg";